// extracted by mini-css-extract-plugin
export default {"ListeMessages":"SuggestionSaisieCodePraticien_ListeMessages__cXc4Y"};